import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 */
export const COMPARISON_BANNER_POSITION = 12;

export function insertProductComparisonBanner(tileListItems: TileListItem[], comparisonId?: string): TileListItem[] {
    const productComparisonBanner = { type: 'PCB' as const };
    if (comparisonId && tileListItems.length >= COMPARISON_BANNER_POSITION) {
        const firstProducts = tileListItems.slice(0, COMPARISON_BANNER_POSITION);
        const remainingProducts = tileListItems.slice(COMPARISON_BANNER_POSITION);
        return [...firstProducts, productComparisonBanner, ...remainingProducts];
    }
    return tileListItems;
}

export function hasProductComparisonBanner(tileListItems: TileListItem[]): boolean {
    return tileListItems.some((item) => item.type === 'PCB');
}
